import {SET_MODAL_ID} from './_CONSTANTS';

export const setModalId = (obj) => {
  return {
    type: SET_MODAL_ID,
    payload: obj
  }
}
